import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'

import ReactImageFallback from 'react-image-fallback'
import imagefallback from '@loyal_images/products/product_placeholder.png'

import IsResponsiveEnabledContext from 'Shared/IsResponsiveEnabledContext'

const DefaultCardImage = ({ altText, imageUrl, href, TaggingClick }) => (
  <div className='card-img col-12 row txt-center py-3 t-1'>
    <div className='row col-12 ml-auto mr-auto t-0 pos-absolute'>
      <div className='col-12 m-0 p-0'>
        <Link to={href} tabIndex={-1} aria-hidden>
          <ReactImageFallback
            tabIndex={-1}
            aria-hidden
            src={imageUrl}
            fallbackImage={imagefallback}
            initialImage={imagefallback}
            alt={altText}
            className='card-image-fallback'
          />
        </Link>
      </div>
    </div>
  </div>
)

DefaultCardImage.propTypes = {
  altText: PropTypes.string,
  imageUrl: PropTypes.string,
  TaggingClick: PropTypes.func,
  href: PropTypes.string
}

const ResponsiveCardImage = ({ altText, imageUrl, visibleByDefault, href, TaggingClick }) => (
  <div className='card-img col-5 row txt-center py-3 my-2'>
    <div className='row col-12 ml-auto mr-auto t-0 pos-absolute p-0'>
      <div className='col-12 pl-0 pr-2'>
        <Link to={href} aria-hidden tabIndex={-1}>
          <ReactImageFallback
            tabIndex={-1}
            aria-hidden
            src={imageUrl}
            fallbackImage={imagefallback}
            initialImage={imagefallback}
            alt={altText}
            className='card-image-fallback pos-absolute l-0'
          />
        </Link>
      </div>
    </div>
  </div>
)

ResponsiveCardImage.propTypes = DefaultCardImage.propTypes

const CardImage = (props) => {
  const isResponsiveEnabled = useContext(IsResponsiveEnabledContext)

  return (
    isResponsiveEnabled ? (
      <Fragment>
        <MediaQuery minWidth={481}>
          <DefaultCardImage {...props} />
        </MediaQuery>
        <MediaQuery maxWidth={480}>
          <ResponsiveCardImage {...props} />
        </MediaQuery>
      </Fragment>
    ) : <DefaultCardImage {...props} />
  )
}

CardImage.propTypes = {
  imageUrl: PropTypes.string,
  TaggingClick: PropTypes.func,
  href: PropTypes.string
}

export default CardImage



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/CardImage/index.js